/** @format */
import { css } from 'styled-components';

import {
    MediaQuery,
    generateGridTemplateColumns,
} from '@toucan/client/global/application';

import { getBackground } from './style-helpers';
import { StyledCategoryBlockProps } from './types';

export const styles = ({ variant }: StyledCategoryBlockProps) => css`
    background: ${getBackground(variant)};
    --original-content-bleed-padding: var(--layout-spacing-24);

    .wrapper {
        padding: var(--layout-spacing-24) 0 var(--layout-spacing-32);
    }

    .category-tiles {
        margin-top: var(--layout-spacing-24);
        display: grid;
        gap: var(--layout-spacing-32) var(--layout-spacing-24);
        justify-content: center;
        grid-template-columns: 1fr;

        ${generateGridTemplateColumns([
            { columns: 2, mediaQuery: MediaQuery.LARGE_TABLET },
            { columns: 1, mediaQuery: MediaQuery.SMALL_TABLET },
            { columns: 2, mediaQuery: MediaQuery.DESKTOP },
            { columns: 4, mediaQuery: MediaQuery.LARGE_DESKTOP },
        ])}
    }
`;
